import { render, staticRenderFns } from "./ProgramSummaryTable.vue?vue&type=template&id=5579cc8e&scoped=true"
import script from "./ProgramSummaryTable.vue?vue&type=script&lang=js"
export * from "./ProgramSummaryTable.vue?vue&type=script&lang=js"
import style0 from "./ProgramSummaryTable.vue?vue&type=style&index=0&id=5579cc8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5579cc8e",
  null
  
)

export default component.exports